// extracted by mini-css-extract-plugin
module.exports = {"orange":"#faa931","blue":"#0d4085"};